﻿/*****
    Author:	    CT Software Systems, LLC
    Last Modified: 251221
*/
'use strict';
import { getPromise, savePromise } from './ctssJQuery.js';
import { getAppToken } from './snSite.js';

const token = getAppToken();

const getBannedMembersAsync = async () => 
    await getPromise({ url: `MembersManagement/${token.CG}/Banned` });
    
const getMuteIconText = (params) => {
    let icon = 'fa-microphone';
    let text = 'Mute';
    let title = 'Mute person...';
    if (params.isMuted) {
        icon = 'fa-microphone-slash';
        text = 'UnMute';
        title = 'UnMute person...';
    }
    return { icon: icon, text: text, title: title };
};

const getMuteMsg = () => 
    'A muted church member is unable to create new prayer requests or comments. ' +
    'Existing prayer requests and comments remain unless they are deleted. ' +
    'A muted church member can be unmuted at any time. Proceed?';
    
const getUnMuteMsg = () =>
    'An unmuted church member is allowed to create new prayer requests and comments. Proceed?';
    
const removeAsync = async (params = {}) => {
    if (!params.mg) {
        alert('mg is a required param for snMemberManagement.removeAsync!');
        return;
    }
    await savePromise({
        url: 'MembersManagement/Remove',
        data: { CG: `${token.CG}`, MG: params.mg }
    });
};

const toggleBannedAsync = async (params = {}) => {
    if (!params.mg) {
        alert('mg is a required param for snMemberManagement.toggleBannedAsync!');
        return;
    }
    await savePromise({
        url: 'MembersManagement/ToggleBanned',
        data: { CG: `${token.CG}`, MG: params.mg },
        divErrMsg: params.divErrMsg
    });
};

const toggleMutedAsync = async (params = {}) => {

    if (!params.mg) {
        alert('mg and isMuted are required params for snMemberManagement.toggleMutedAsync!');
        return;
    }
    await savePromise({
        url: 'MembersManagement/ToggleMuted',
        data: { MG: params.mg, IsMuted: params.isMuted },
        divErrMsg: params.divErrMsg
    });
};


export {
    getBannedMembersAsync,
    getMuteIconText,
    getMuteMsg,
    getUnMuteMsg,
    removeAsync,
    toggleBannedAsync,
    toggleMutedAsync
};